/** Qual visualizador o anexo do Registro de Atividade recebe. */
export type AttachmentViewerKind = 'image' | 'pdf' | 'other'

const IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.bmp',
  '.svg',
  '.heic',
  '.heif'
]

/**
 * Escolhe o visualizador pelo mime REAL do anexo (campo do DTO, quando existir, ou o
 * `Content-Type` da resposta do download — ver `ActivityAuditAttachment.mimeType` e
 * `DsAttendanceActivityAudit.vue`), nunca pelo sufixo do nome do arquivo: era isso que
 * quebrava a tela quando o nome do anexo não batia com o conteúdo real (ex.: um PDF
 * salvo com nome `.jpg`, ou vice-versa).
 *
 * `fileName` só entra como ÚLTIMO recurso, quando nenhum mime real está disponível
 * (fixtures antigas, backend sem o header, upload legado) — mantém o comportamento
 * anterior nesse caso degradado em vez de forçar tudo para "other".
 */
export function classifyAttachmentViewer(
  mimeType: string | null | undefined,
  fileName?: string | null
): AttachmentViewerKind {
  const normalizedMimeType = mimeType ? mimeType.toLowerCase().trim() : ''

  if (normalizedMimeType) {
    if (normalizedMimeType === 'application/pdf') return 'pdf'
    if (normalizedMimeType.startsWith('image/')) return 'image'
    return 'other'
  }

  const lowerFileName = (fileName ?? '').toLowerCase()
  if (!lowerFileName) return 'other'
  if (lowerFileName.endsWith('.pdf')) return 'pdf'
  if (IMAGE_EXTENSIONS.some((ext) => lowerFileName.endsWith(ext))) return 'image'
  return 'other'
}
